import React, { useState } from 'react';
import { Form, Input, Button, Select, message, Row, Col } from 'antd';
import axios from 'axios';
import InputMask from 'react-input-mask';

const { Option } = Select;

const ClientForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [maxLength, setMaxLength] = useState(14); // para CNPJ/CPF

  // ✅ Pegando o usuário logado
  const user = JSON.parse(sessionStorage.getItem('user'));
  const userId = user?.ID_USUARIO || null;

  const handleTipoClienteChange = (value) => {
    if (value === 'PF') {
      setMaxLength(11); // CPF tem 11 dígitos
      form.setFieldsValue({ CNPJ_CPF: '' });
    } else {
      setMaxLength(14); // CNPJ tem 14 dígitos
      form.setFieldsValue({ CNPJ_CPF: '' });
    }
  };

  const handleFinish = async (values) => {
    try {
      setLoading(true);

      if (!userId) {
        message.error('Usuário não autenticado.');
        setLoading(false);
        return;
      }

      const cnpjCpfLimpo = (values.CNPJ_CPF || '').replace(/\D/g, '');

      if (form.getFieldValue('TIPO_CLIENTE') === 'PF' && cnpjCpfLimpo.length !== 11) {
        message.error('CPF deve ter 11 números.');
        setLoading(false);
        return;
      }
      if (form.getFieldValue('TIPO_CLIENTE') === 'PJ' && cnpjCpfLimpo.length !== 14) {
        message.error('CNPJ deve ter 14 números.');
        setLoading(false);
        return;
      }

      const cepLimpo = (values.CEP || '').replace(/\D/g, '');
      const telefoneRaw = values.TELEFONE || '';
      const telefoneLimpo = telefoneRaw.replace(/\D/g, '');

      const payload = {
        ...values,
        CNPJ_CPF: cnpjCpfLimpo,
        TELEFONE: telefoneLimpo,
        CEP: cepLimpo,
        ID_USUARIO: userId,
      };

      await axios.post('/api/clientes', payload);
      message.success('Cliente cadastrado com sucesso!');
      form.resetFields();
      setMaxLength(14);
    } catch (error) {
      console.error(error);
      message.error('Erro ao cadastrar cliente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#fff', paddingRight: 24, minHeight: '100vh' }}>
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Row gutter={[6, 6]}>
          <Col span={8}>
            <Form.Item
              name="TIPO_CLIENTE"
              label="Tipo de Cliente"
              rules={[{ required: true, message: 'Selecione o tipo' }]}
            >
              <Select placeholder="Selecione" onChange={handleTipoClienteChange}>
                <Option value="PJ">Pessoa Jurídica</Option>
                <Option value="PF">Pessoa Fsica</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="RAZAO_SOCIAL"
              label="Razão Social"
              rules={[{ required: true, message: 'Digite a razão social' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="NOME_FANTASIA"
              label="Nome Fantasia"
              rules={[{ required: true, message: 'Digite o nome fantasia' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="RESPONSAVEL"
              label="Responsável"
              rules={[{ required: true, message: 'Digite o responsável' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="CNPJ_CPF"
              label="CNPJ ou CPF"
              rules={[{ required: true, message: 'Informe o CNPJ ou CPF' }]}
            >
              <Input maxLength={maxLength} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="INSCRICAO_ESTADUAL" label="Inscrição Estadual">
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="TELEFONE" label="Telefone">
              <InputMask mask="(99)99999-9999" maskChar={null}>
                {(inputProps) => <Input {...inputProps} />}
              </InputMask>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="EMAIL" label="Email">
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="CEP"
              label="CEP"
              rules={[{ required: true, message: 'Digite o CEP' }]}
            >
              <InputMask mask="99999-999" maskChar={null}>
                {(inputProps) => <Input {...inputProps} maxLength={9} />}
              </InputMask>
            </Form.Item>
          </Col>

          <Col span={16}>
            <Form.Item
              name="ENDERECO"
              label="Endereço"
              rules={[{ required: true, message: 'Digite o endereço' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="NUMERO"
              label="Número"
              rules={[{ required: true, message: 'Digite o número' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="COMPLEMENTO" label="Complemento">
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="BAIRRO"
              label="Bairro"
              rules={[{ required: true, message: 'Digite o bairro' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="CIDADE"
              label="Cidade"
              rules={[{ required: true, message: 'Digite a cidade' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="ESTADO"
              label="Estado"
              rules={[{ required: true, message: 'Selecione o estado' }]}
            >
              <Select placeholder="Selecione o estado">
                <Option value="AC">AC</Option>
                <Option value="AL">AL</Option>
                <Option value="AP">AP</Option>
                <Option value="AM">AM</Option>
                <Option value="BA">BA</Option>
                <Option value="CE">CE</Option>
                <Option value="DF">DF</Option>
                <Option value="ES">ES</Option>
                <Option value="GO">GO</Option>
                <Option value="MA">MA</Option>
                <Option value="MT">MT</Option>
                <Option value="MS">MS</Option>
                <Option value="MG">MG</Option>
                <Option value="PA">PA</Option>
                <Option value="PB">PB</Option>
                <Option value="PR">PR</Option>
                <Option value="PE">PE</Option>
                <Option value="PI">PI</Option>
                <Option value="RJ">RJ</Option>
                <Option value="RN">RN</Option>
                <Option value="RS">RS</Option>
                <Option value="RO">RO</Option>
                <Option value="RR">RR</Option>
                <Option value="SC">SC</Option>
                <Option value="SP">SP</Option>
                <Option value="SE">SE</Option>
                <Option value="TO">TO</Option>
              </Select>
            </Form.Item>
          </Col>

          <Form.Item style={{ marginTop: 24 }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Cadastrar Cliente
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
};

export default ClientForm;
